import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import image from "../images/hands2.png";
import { Fade } from "react-reveal";

const ThirdContent = () => {
  return (
    <ContentWrapper>
      <div>
        <img src={image} alt="foto tema saúde" />
        <Fade left>
          <h1>Sua saúde é a nossa missão</h1>
          <a href="https://api.whatsapp.com/send?phone=5511917721058&text=Olá%20Quero%20saber%20mais%20Sobre%20Clínica%20de%20Recuperação">
            <button>Faça um orçamento agora</button>
          </a>
        </Fade>
      </div>
    </ContentWrapper>
  );
};
export default ThirdContent;

const ContentWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: white;
  font-size: 70px;
  line-height: 1;
  font-family: "Jost", sans-serif;
  font-weight: 600;
  position: relative;
  overflow-y: hidden;
  background-color: rgba(0, 0, 0, 0.6);
  div {
    padding-top: 5%;
    height: 100%;
  }

  img {
    width: 100%;
    position: absolute;
    object-fit: fill;
    top: 0%;
    left: 0;
    z-index: -1;
  }

  button {
    box-shadow: 0 0.25rem 0 hsl(0deg 0% 100% / 25%);
    background-color: transparent;
    border-color: hsla(0, 0%, 100%, 0.7);
    font-size: 1.25rem;
    line-height: 1.6;
    font-family: "Jost", sans-serif;
    font-weight: 500;
    width: 300px;
    height: 64px;
    border-radius: 5px;
    color: white;
    margin-bottom: 5%;
  }
  @media (max-width: 900px) {
    font-size: 1.5rem;
    line-height: 1.5;
    button {
      width: 150px;
      height: 34px;
      font-weight: 200;
      line-height: 1rem;
      font-size: 0.6rem;
    }
  }
`;
